import posthog from "posthog-js";

const isDev = process.env.NODE_ENV === "development";
// Desativado globalmente (local e produção) para eliminar qualquer suspeita
// de atraso causado pelo PostHog (autocapture/session recording) enquanto
// investigamos a lentidão do grid de relatórios. Trocar para `false` (ou
// reintroduzir a flag por .env) quando quiser voltar a coletar eventos.
const DISABLE_POSTHOG = true;

if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    enableExceptionAutocapture: true,
    person_profiles: "identified_only",
    opt_out_capturing_by_default: DISABLE_POSTHOG,
    disable_session_recording: DISABLE_POSTHOG,
    loaded: (ph) => {
      if (DISABLE_POSTHOG) {
        console.log("🔌 [PostHog] Inicializado no modo OPT-OUT (desativado globalmente). Nenhum evento será enviado.");
      } else if (isDev) {
        ph.debug(); // Habilita o console de depuração automática do PostHog localmente
        console.log("⚡ [PostHog] Inicializado em modo DEBUG. Eventos estão sendo enviados.");
      }
    },
  });
} else {
  if (isDev) {
    console.warn("⚠️ [PostHog] REACT_APP_PUBLIC_POSTHOG_KEY não configurada no arquivo .env.");
  }
}

export default posthog;

